import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import * as eventActions from '../../actions/event-actions';
import { fetchComponentConfig } from '../../actions/component-config-actions';
import DrawsTabContent from '../../components/EventProfile/DrawsTabContent';
import { setAuthHeader, setAuthUser } from '../../actions';

const WebViewEventDraws = (props) => {
    const parsed = queryString.parse(props.location.search);
    const { jwt, ispower } = parsed;
    if (jwt) {
        props.setAuthHeader({ jwt });
    }

    const event = props.events.currentEvent.data;

    const getEvent = async () => {
        await props.getEvent(props.match.params.eventId);
        if (!props.events.currentEvent.error) {
            props.defaultInitDrawsTabState();
        }
    };

    useEffect(() => {
        props.getComponentConfig(props.match.params.eventId);
        props.setAuthUser({ id: 12345, isPowered: ispower });
    }, []);

    useEffect(() => {
        // eslint-disable-next-line eqeqeq
        if (!props.events.currentEvent.isLoading && props.events.currentEvent.data?.id != props.match.params.eventId) {
            getEvent();
        } else if (props.events.currentEvent.data?.draws) {
            props.defaultInitDrawsTabState();
        }
    }, [props.events.currentEvent.data, props.events.currentEvent.isLoading]);

    return (event ? (
        <div className="p24" data-testid="webview.event-draws.container">
            <DrawsTabContent
                isCurrentMemberAdmin={false}
                collapsed={false}
                data-testid="webview.event-draws.draws-content"
            />
        </div>
    ) : null);
};

function mapDispatchToProps(dispatch) {
    return {
        getEvent: (eventId) => {
            return dispatch(eventActions.getDrawsViewEvent(eventId));
        },
        getComponentConfig: (eventId) => {
            return dispatch(fetchComponentConfig('event-profile', { eventId }));
        },
        setAuthHeader: ({ jwt }) => {
            return dispatch(setAuthHeader({ jwt }));
        },
        setAuthUser: (args) => {
            return dispatch(setAuthUser(args));
        },
        defaultInitDrawsTabState: () => {
            return dispatch(eventActions.defaultInitDrawsTabState());
        },
    };
}

function mapStateToProps({ events }) {
    return { events };
}

const component = connect(mapStateToProps, mapDispatchToProps)(WebViewEventDraws);

export default {
    component,
    loadData: ({ dispatch }, match) => {
        dispatch(eventActions.getEventMetaData(match.params.eventId));
        dispatch(eventActions.getDrawsViewEvent(match.params.eventId));
    },
};
